<div>
  <!--<div [style.display]="state.value === 'inactive' ? 'none' : ''">-->
  @if (options.closeButton) {
    <a (click)="remove()" class="btn btn-close">
      <i class="fad fa-times-circle"></i>
    </a>
  }
  <div class="d-flex align-items-center">
    @if (options['icon']) {
      <div class="toastr-icon"><i [class]="options['icon']"></i></div>
    }
    <div>
      @if (title) {
        <div class="toastr-title" [class]="options.titleClass" [attr.aria-label]="title">
          <div class="text">{{ title }}</div>
        </div>
      }
      @if (message && options.enableHtml) {
        <div class="toastr-message" role="alert" aria-live="polite" [class]="options.messageClass" [innerHTML]="message"></div>
      }
      @if (message && !options.enableHtml) {
        <div class="toastr-message" role="alert" aria-live="polite" [class]="options.messageClass" [attr.aria-label]="message">
          {{ message }}
        </div>
      }
      <!--            <div class="buttons">-->
      <!--                <button *ngFor="let button of buttons">{{ button.title }}</button>-->
      <!--            </div>-->
    </div>
  </div>
</div>
@if (options.progressBar) {
  <div>
    <div class="toast-progress" [style.width]="width + '%'"></div>
  </div>
}
